import React from 'react';
import { Link } from 'react-router-dom';
import '../Style/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span className="footer-logo">GLPT</span>
          <p className="footer-tagline">Set goals, track progress, and stay consistent.</p>
        </div>

        <nav className="footer-links" aria-label="Footer navigation">
          <Link to="/help">Guide</Link>
          <Link to="/settings/install">Install App</Link>
        </nav>

        <div className="footer-bottom">
          <p>&copy; {currentYear} GLPT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
